





































import { Component, Mixins } from "vue-property-decorator";
import { Size } from "../../../../../../../domain/drawing";
import { ClaioContentsToolMixin } from "../../mixins";
import ClaioImageThumbnail from "../../claio/ClaioImageThumbnail.vue";
import ClaioImageFinder from "../../claio/ClaioImageFinder.vue";
import ClaioImagePreview from "../../claio/ClaioImagePreview.vue";

@Component({
  components: {
    ClaioImageThumbnail,
    ClaioImageFinder,
    ClaioImagePreview,
  }
})
export default class ClaioContentsTool extends Mixins(ClaioContentsToolMixin) {
  mounted() {
    this.thumbnailSize = new Size(120, 120);
    this.isFitted = false;
  }
}
